import { createContext, useContext } from "react";

import { AiChatResourceType } from "components/ai_chat/types";
import { AiResourceType } from "lib/core_components/ai/types";

/**
 * resourceId - ID of the resource to query
 * resourceName - Display name of the resource
 * resourceType - Category of AI chat for context
 */
type AiContextType = {
  resourceId?: string;
  resourceName: string;
  resourceType: AiResourceType | AiChatResourceType;
  // additional data for specific chats
  bidId?: string;
};

const AiContext = createContext<AiContextType | undefined>(undefined);

export function AiContextProvider({
  children,
  context,
}: {
  children: React.ReactNode;
  context: AiContextType;
}) {
  return <AiContext.Provider value={context}>{children}</AiContext.Provider>;
}

export const useAiContext = () => {
  const context = useContext(AiContext);
  if (!context) throw new Error("useAiContext must be used within an AiContextProvider");
  return context;
};
